const getNotifications = state => state.notifications
export const getLastNotifications = state =>
    getNotifications(state).notifications[0]
